module.exports = __webpack_public_path__ + "img/icon-figma.b9b7becf.svg";